// Per-field "this came out of the brand guide, nobody has checked it" marker.
//
// WHY IT EXISTS. The wizard's last step activates the site, and there is no
// review gate after that — a value read out of a PDF goes public the moment the
// staff member selects Go live. So an extracted value is marked wherever it is
// EDITABLE, not only on the upload screen: the staff member's walk through
// Identity, Colors & fonts and Hero & contact IS the review, and a marker they
// never pass is a marker that does nothing.
//
// The mark is TRANSPORT-ONLY. It lives in wizard state for the length of the
// session, is never sent to the server, and has no column: it exists to be
// caught before go-live, and once it has been the value is just the value.
// It clears the moment the field is edited — editing IS reviewing.

/** Field keys are free-form so a grouped section can mark a nested token
 *  ("color.primary") with the same component that marks a flat field. */
export interface PartnerBrandExtractedMarkerProps {
  /** Identifies the field, and forms the test id: `ai-extracted-{field}`. */
  field: string;
  /** Optional leading text — used where the marker stands in for the field's
   *  own label (the grouped Colors / Contact sections own their labels). */
  label?: string;
}

export function PartnerBrandExtractedMarker({
  field,
  label,
}: PartnerBrandExtractedMarkerProps) {
  return (
    <span
      className="ml-space-1 inline-block px-space-1 rounded-sm bg-status-warning/20 text-status-warning text-caption"
      data-testid={`ai-extracted-${field}`}
    >
      {label ? `${label} — from brand guide` : "from brand guide"}
    </span>
  );
}
